import createCache from "@emotion/cache";
import { CacheProvider, EmotionCache } from "@emotion/react";
import CssBaseline from "@mui/material/CssBaseline";
import { Theme, ThemeProvider, createTheme } from "@mui/material/styles";
import { AppProps } from "next/app";
import Head from "next/head";
import { purple, red } from "@mui/material/colors";
import Router from "next/router";
import NProgress from "nprogress";

export interface MyAppProps extends AppProps {
  emotionCache?: EmotionCache;
  theme?: Theme;
}

const defaultTheme = createTheme({
  palette: {
    primary: {
      main: red[500],
    },
    secondary: {
      main: purple[500],
    },
  },
});

Router.events.on("routeChangeStart", () => {
  NProgress.start();
});
Router.events.on("routeChangeError", () => {
  NProgress.done();
});
Router.events.on("routeChangeComplete", () => {
  NProgress.done();
});

export default function SalifyNextApp(props: MyAppProps) {
  const {
    Component,
    theme = defaultTheme,
    emotionCache = createCache({ key: "mui" }),
    pageProps,
  } = props;

  return (
    <CacheProvider value={emotionCache}>
      <Head>
        <meta name="viewport" content="initial-scale=1, width=device-width" />
      </Head>

      <ThemeProvider theme={theme}>
        <CssBaseline />
        <Component {...pageProps} />
      </ThemeProvider>
    </CacheProvider>
  );
}
